<template>
  <v-flex xs12 ma-4>
    <v-row>
      <v-col>
        <v-card
          outlined
          tile
        >
          <v-card-title>Export files:</v-card-title>
          <v-card-text>
            <v-row
              align="center"
              justify="space-around"
            >
              <v-col align="center">
                <v-btn
                  title="Fix export content"
                  @click="fixExportContentDialog.show = true"
                >
                  Fix export content
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="fixExportContentDialog.show"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
            <span class="headline">
              Fix export content
            </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-file-input
                  v-model="fixExportContentDialog.file"
                  :loading="fixExportContentDialog.loading"
                  label="Archive with content"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="fixExportContentDialog.ids"
                  label="Exclude poi ids"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="resetFixExportContentDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="fixExportContent"
            :loading="fixExportContentDialog.loading"
            color="blue darken-1"
            text
          >
            Fix
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Tools',
  data: () => ({
    fixExportContentDialog: {
      show: false,
      loading: false,
      ids: '',
      file: null,
    },
    loading: true,
  }),

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    fixExportContent() {
      if (!this.fixExportContentDialog.file) {
        return;
      }

      this.fixExportContentDialog.loading = true;

      this.$nextTick(() => {
        const data = new FormData();
        data.append('file', this.fixExportContentDialog.file);
        data.append('ids', this.fixExportContentDialog.ids);

        this.$requestHelpers
          .post('api/admin/export/fix-export-content',
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              responseType: 'blob',
            })
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            fileLink.click();
          }).catch(async (error) => {
            let text = error.response?.data?.message ? error.response.data.message : 'Error';
            if ((error.response?.data) instanceof Blob) {
              const json = JSON.parse(await error.response.data.text());
              text = json.message;
            }
            this.setSnack({
              color: 'red',
              text,
            });
          }).finally(() => {
            this.resetFixExportContentDialog();
          });
      });
    },

    resetFixExportContentDialog() {
      this.fixExportContentDialog.show = false;
      this.fixExportContentDialog.loading = false;
      this.fixExportContentDialog.ids = '';
      this.fixExportContentDialog.file = null;
    },
  },
};
</script>
